import { render, staticRenderFns } from "./OvertimeWork.vue?vue&type=template&id=58b7598c&scoped=true&"
import script from "./OvertimeWork.vue?vue&type=script&lang=js&"
export * from "./OvertimeWork.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeWork.vue?vue&type=style&index=0&id=58b7598c&prod&lang=css&"
import style1 from "./OvertimeWork.vue?vue&type=style&index=1&id=58b7598c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7598c",
  null
  
)

export default component.exports